import { Check } from '@mui/icons-material';
import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import CostItemForm from './CostItemForm';
import EarnItemForm from './EarnItemForm';
import { useNavigate, useParams } from 'react-router-dom';
import useEarnItems from 'hooks/useEarnItems';
import { useEffect } from 'react';
import { useAlerts } from 'hooks';
import CoinRateForm from './CoinRateForm';
import useCoinRate from 'hooks/useCoinRate';

const CoinRateEdit = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { findCoinRate, isLoading, coinRate, handleChange, updateCoinRate } =
		useCoinRate();
	const { showAlertSuccess, showAlertError } = useAlerts();

	const demoCoinRate = {
		name: 'Double Coins',
		coins: 20,
		xp: 5,
		id: 2
	};

	const handleSaveClick = async () => {
		try {
			if (!coinRate.name || coinRate.coins < 1 || coinRate.xp < 1) {
				showAlertError('Please fill out all fields');
				return;
			}
			await updateCoinRate(coinRate);
			showAlertSuccess('Coin rate updated successfully');
			navigate('/coin-rates', { replace: true });
		} catch (err) {
			showAlertError('Failed to update coin rate');
		}
	};

	useEffect(() => {
		if (id) findCoinRate(id);
	}, [id]);

	return (
		<>
			<Subheader
				title="Edit Coin Rate"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save
					</Button>
				]}
			/>

			<Container>
				<Paper>
					<Box p={4}>
						<CoinRateForm coinRate={coinRate} handleChange={handleChange} />
						<Box py={2}>
							<Button
								color="primary"
								variant="contained"
								startIcon={<Check />}
								onClick={handleSaveClick}
							>
								Save
							</Button>
						</Box>
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default CoinRateEdit;
